module.exports = __webpack_public_path__ + "img/btn_pause.00b81e64.svg";